import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import apiRoutes from '../api/routes';
import { Settings } from '../api/models/Settings';

export const defaultLng: string = 'nl-be';

export const initI18n = (domainLanguage: string, settings: Settings) => {
  return i18n
    .use(HttpApi)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      debug: false,
      lng: domainLanguage,
      fallbackLng: settings.fallbackLanguage,
      supportedLngs: settings.availableLanguages,
      lowerCaseLng: true,
      react: {
        useSuspense: false,
      },
      interpolation: {
        escapeValue: false,
      },
      backend: {
        loadPath: apiRoutes.translations,
      },
    });
};
